<template>
    <v-container fluid>
        <v-layout row wrap class="hidden-sm-and-up">
            <v-flex xs12>
                <v-tabs
                        color="grey"
                        dark
                        slider-color="yellow"
                >
                    <v-tab ripple>Particulier</v-tab>
                    <v-tab ripple to="/corporatif">Corporatif</v-tab>
                </v-tabs>
            </v-flex>
        </v-layout>

    <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-text class="grey darken-4 white--text text-lg-left"><h1>Forfaits mise au point</h1></v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout>
        <v-flex xs12>
    <v-data-table
            v-model="selected"
            :headers="headers"
            :items="desserts"
            item-key="name"
            class="elevation-1"
            hide-actions
    >
        <template slot="headers" slot-scope="props">
            <tr>
                <th class="grey darken-1 white--text hidden-xs-only" width="34%"><h1></h1></th>
                <th class="grey darken-1 white--text hidden-sm-and-up" width="15%"><h1></h1></th>
                <th class="red darken-2 white--text text-xl-center text-uppercase hidden-xs-only" width="22%"><h3>Rapide 69.99$</h3></th>
                <th class="red darken-2 white--text text-xs-center text-uppercase hidden-sm-and-up Rtable-cell-header"><h3>Rapide </br> 69.99$</h3></th>
                <th class="red darken-2 white--text text-xl-center text-uppercase hidden-xs-only" width="22%"><h3>Base 99.99$</h3></th>
                <th class="red darken-2 white--text text-xs-center text-uppercase hidden-sm-and-up Rtable-cell-header"><h3>Base </br> 99.99$</h3></th>
                <th class="red darken-2 white--text text-xl-center text-uppercase hidden-xs-only" width="22%"><h3>Avancée 169.99$</h3></th>
                <th class="red darken-2 white--text text-xs-center text-uppercase hidden-sm-and-up Rtable-cell-header"><h3>Avancée </br> 169.99$</h3></th>
            </tr>
        </template>
        <template slot="items" slot-scope="props">
            <tr :active="props.selected" @click="props.selected = !props.selected">
                <td align="center">{{ props.item.name }}</td>
                <td class="text-xs" align="center">{{ props.item.calories }}</td>
                <td class="text-xs" align="center">{{ props.item.fat }}</td>
                <td class="text-xs" align="center">{{ props.item.carbs }}</td>
            </tr>
        </template>
    </v-data-table>
        </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-text class="grey darken-4 white--text text-lg-left"><h1>Services à la carte</h1></v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-flex xs12>
            <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="directionTransmission"
                    item-key="name"
                    class="elevation-1"
                    hide-actions
            >
                <template slot="headers" slot-scope="props">
                    <tr>
                        <th class="grey darken-3 white--text text-xl-center text-uppercase" width="35%"><h3>Direction</h3></th>
                        <th class="red darken-2 white--text text-xl-center" width="15%"><h3>$</h3></th>
                        <th class="grey darken-3 white--text text-xl-center text-uppercase" width="35%"><h3>Transmission</h3></th>
                        <th class="red darken-2 white--text text-xl-center" width="15%"><h3>$</h3></th>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr :active="props.selected" @click="props.selected = !props.selected">
                        <td class="text-xs" align="center">{{ props.item.named }}</td>
                        <td class="text-xs" align="center">{{ props.item.priced }}</td>
                        <td class="text-xs" align="center">{{ props.item.namet }}</td>
                        <td class="text-xs" align="center">{{ props.item.pricet }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>

        <v-divider></v-divider>

        <v-flex xs12>
            <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="vitesseFrein"
                    item-key="name"
                    class="elevation-1"
                    hide-actions
            >
                <template slot="headers" slot-scope="props">
                    <tr>
                        <th class="grey darken-3 white--text text-xl-center text-uppercase" width="35%"><h3>Vitesse</h3></th>
                        <th class="red darken-2 white--text text-xl-center" width="15%"><h3>$</h3></th>
                        <th class="grey darken-3 white--text text-xl-center text-uppercase" width="35%"><h3>Frein</h3></th>
                        <th class="red darken-2 white--text text-xl-center" width="15%"><h3>$</h3></th>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr :active="props.selected" @click="props.selected = !props.selected">
                        <td class="text-xs" align="center">{{ props.item.nameV }}</td>
                        <td class="text-xs" align="center">{{ props.item.priceV }}</td>
                        <td class="text-xs" align="center">{{ props.item.nameF }}</td>
                        <td class="text-xs" align="center">{{ props.item.priceF }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>

        <v-divider></v-divider>

        <v-flex xs12>
            <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="accessoireRoue"
                    item-key="name"
                    class="elevation-1"
                    hide-actions
            >
                <template slot="headers" slot-scope="props">
                    <tr>
                        <th class="grey darken-3 white--text text-xl-center text-uppercase" width="35%"><h3>Accessoire</h3></th>
                        <th class="red darken-2 white--text text-xl-center" width="15%"><h3>$</h3></th>
                        <th class="grey darken-3 white--text text-xl-center text-uppercase" width="35%"><h3>Roue</h3></th>
                        <th class="red darken-2 white--text text-xl-center" width="15%"><h3>$</h3></th>
                    </tr>
                </template>
                <template slot="items" slot-scope="props">
                    <tr :active="props.selected" @click="props.selected = !props.selected">
                        <td class="text-xs" align="center">{{ props.item.nameA }}</td>
                        <td class="text-xs" align="center">{{ props.item.priceA }}</td>
                        <td class="text-xs" align="center">{{ props.item.nameR }}</td>
                        <td class="text-xs" align="center">{{ props.item.priceR }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
    </v-container>


<!--footer-->
        <v-layout justify-center>
            <v-flex xs12>
                <v-footer
                        dark
                        height="auto">
                    <v-card
                            class="flex"
                            flat
                            tile>
                        <v-card-title class="teal">
                            <h2>SUIVEZ-NOUS!</h2>
                            <v-divider light></v-divider>
                            <v-btn fab light href="https://www.facebook.com/veloshop.ca/" target="_blank">
                                <v-icon size="24px">fab fa-facebook</v-icon>
                            </v-btn>
                            <v-btn fab light href="https://www.instagram.com/veloshop.ca/?hl=en" target="_blank">
                                <v-icon size="24px">fab fa-instagram</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card-actions class="grey darken-3 justify-center">
                            &copy;2019 — <strong>Véloshop.ca</strong>
                        </v-card-actions>

                    </v-card>
                </v-footer>
            </v-flex>
        </v-layout>


    </v-container>
</template>

<script>
    export default {
        name: 'Particulier',
        data: () => ({
            selected: [],
            headers: [
                {
                    align: 'left'
                }
            ],
            desserts: [
                {
                    name: 'Ajustement des freins',
                    calories: 'X',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name: 'Ajustement des vitesses',
                    calories: 'X',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name: 'Lubrification de la chaine',
                    calories: 'X',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                  name: 'Ajustement de la pression des pneus',
                    calories: 'X',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name: 'Inspection du cadre et composantes',
                    calories: '',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name: 'Ajustement des moyeux',
                    calories: '',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name: 'Ajustement du boîtier de pédalier',
                    calories: '',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name: 'Ajustement du jeu de direction',
                    calories: '',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name: 'Alignement mineur des roues',
                    calories: '',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name : 'Nettoyage du vélo',
                    calories: '',
                    fat: 'X',
                    carbs: 'X'
                },
                {
                    name: 'Alignement de la patte de dérailleur',
                    calories:'',
                    fat: '',
                    carbs: 'X'
                },
                {
                    name: 'Nettoyage et graissage des moyeux, jeu de direction et\n' +
                        'boîtier de pédalier',
                    calories: '',
                    fat: '',
                    carbs: 'X'
                }

            ],
            directionTransmission: [
                {
                    named: 'Ajustement du jeu de direction',
                    priced: 7,
                    namet: 'Remplacer la chaine',
                    pricet: 10
                },
                {
                    named: 'Graissage du jeu de direction',
                    priced: 15,
                    namet: 'Remplacer la cassette / roue libre',
                    pricet: 10
                },
                {
                    named: 'Installation du jeu de direction',
                    priced: 25,
                    namet: 'Graissage du boitier de pédalier',
                    pricet: 20
                },
                {
                    named: 'Poser guidoline',
                    priced: 15,
                    namet: 'Ajustement du boitier de pédalier',
                    pricet: 10
                },
                {
                    named: 'Poser des poignées',
                    priced: 7,
                    namet: 'Remplacer pédalier',
                    pricet: 15
                },
                {
                    named: 'Remplacer le guidon (avec guidoline)',
                    priced: 35,
                    namet: 'Remplacer plateau',
                    pricet: 15
                },
                {
                    named: 'Remplacer le guidon (sans guidoline)',
                    priced: 20,
                    namet: 'Poser des pédales',
                    pricet: 10
                },
                {
                    named: 'Remplacer la potence',
                    priced: 10,
                    namet: 'Graissage des pédales',
                    pricet: 15
                },
                {
                    named: 'Remplacer la fourche',
                    priced: 25,
                    namet: 'Nettoyage de la transmission',
                    pricet: 65
                },
                {
                    named: 'Couper la fourche',
                    priced: 12,
                    namet: '',
                    pricet: ''
                },
                {
                    named: 'Entretien fourche à suspension',
                    priced: 100,
                    namet: '',
                    pricet: ''
                },
            ],
            vitesseFrein: [
                {
                    nameV: 'Ajustement du dérailleur',
                    priceV: 12,
                    nameF: 'Ajustement et/ou remplacement des patins du frein',
                    priceF: 10
                },
                {
                    nameV: 'Poser cable et/ou gaine de vitesse',
                    priceV: 15,
                    nameF: 'Remplacer cable et/ou gaine de frein (sans guidoline)',
                    priceF: 13
                },
                {
                    nameV: 'Remplacer manette de vitesse (sans guidoline)',
                    priceV: 15,
                    nameF: 'Remplacer manette de frein (sans guidoline)',
                    priceF: 10
                },
                {
                    nameV: 'Remplacer manette de vitesse (avec guidoline)',
                    priceV: 20,
                    nameF: 'Remplacer manette de frein (avec guidoline)',
                    priceF: 25
                },
                {
                    nameV: 'Remplacer dérailleur',
                    priceV: 20,
                    nameF: 'Purge de frein hydraulique',
                    priceF: 40
                },
                {
                    nameV: 'Alignement de la patte de derailleur arrière',
                    priceV: 18,
                    nameF: 'Remplacer frein',
                    priceF: 15
                }

            ],
            accessoireRoue:[
                {
                    nameA: 'Poser garde boue (av. et ar.)',
                    priceA: 16,
                    nameR: 'Remplacer chambre à air',
                    priceR: 10
                },
                {
                    nameA: 'Poser porte baggage',
                    priceA: 10,
                    nameR: 'Remplacement pneus',
                    priceR: 10
                },
                {
                    nameA: 'Poser une béquille',
                    priceA: 7,
                    nameR: 'Alignement mineur',
                    priceR: 15
                },
                {
                    nameA: 'Poser un cadenas',
                    priceA: 7,
                    nameR: 'Alignement majeur',
                    priceR: 30
                },
                {
                    nameA: 'Poser un odomètre (avec fil)',
                    priceA: 15,
                    nameR: 'Ajustement du moyeu',
                    priceR: 10
                },
                {
                    nameA: 'Poser un odomètre (sans fil)',
                    priceA: 10,
                    nameR: 'Graissage moyeux',
                    priceR: 15
                },
                {
                    nameA: 'Poser un systéme "roue anti-vol"',
                    priceA: 10,
                    nameR: 'Remplacer roue av.',
                    priceR: 12
                },
                {
                    nameA: 'Poser un porte gourde',
                    priceA: 5,
                    nameR: 'Remplacer roue ar.',
                    priceR: 15
                },
                {
                    nameA: 'Installation de cales',
                    priceA: 12,
                    nameR: 'Montage de roue',
                    priceR: 75
                },
                {
                    nameA: 'Installation de cales-pied',
                    priceA: 12,
                    nameR: '',
                    priceR: ''
                },
            ]
        }),

        methods: {
            toggleAll () {
                if (this.selected.length) this.selected = []
                else this.selected = this.desserts.slice()
            }
        }
    }
</script>

<style scoped>

    tr:nth-child(even) {
        background-color: #dddddd;
    }

    @media
    only screen and (max-width: 600px),
    (min-device-width: 320px) and (max-device-width: 480px) {

        th{
            padding: 0 !important;
            font-size: 2.5vw !important;
            padding-left: 2px !important;
        }

        td{
            padding: 2px !important;
            width: 20%;
        }

    }

</style>
